/* eslint-disable react-hooks/rules-of-hooks */
import Button from '@/components/atoms/Button'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { drawerCreators } from '@/store/ducks/drawer'
import Icon from '@/components/atoms/Icon'
import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'
import profileService from '@/services/profileService'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { matriculateCreators } from '@/store/ducks/matriculate'
import onboardingService from '@/services/onboardingService'
import { modalCreators } from '@/store/ducks/modal'

export default function DrawerCourseLive() {
	const {
		auth: { user },
		drawer: { drawerInfo, disabledOnClose },
	} = useAppSelector((state) => state)
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	async function closeModal() {
		await dispatch(drawerCreators.closeDrawer())
	}

	const {
		execute: editProfile,
		isLoading,
		isSuccess,
	} = profileService.editMutation()

	const {
		execute: nextProgress,
		isLoading: isLoadingOnboarding,
		isSuccess: isSuccessOnboarding,
	} = onboardingService.progressStudent()

	const handleMatriculatedLive = async () => {
		await dispatch(
			matriculateCreators.setClassSelect({
				id: drawerInfo?.curso_id,
				name: drawerInfo?.name_course || '',
				curso_id: drawerInfo?.curso_id || 0,
				'type-course': 'AO VIVO',
			})
		)

		nextProgress(
			{
				step: 0,
				curso_id: drawerInfo?.curso_id,
			},
			() => {
				editProfile({ curso_id: drawerInfo?.curso_id })
				navigate('/curso')
				dispatch(
					modalCreators.openModal({
						name: 'newJourneyModal',
						disabledOnClose: true,
					})
				)
			}
		)
	}

	useEffect(() => {
		if (isSuccess || isSuccessOnboarding) closeModal()

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess, isSuccessOnboarding])

	const typeCourse = drawerInfo?.['type-course']?.toUpperCase() ?? ''
	const findOnboarding = user?.onboarding_all?.find(
		(onboading) => onboading.curso_id === drawerInfo?.curso_id
	)

	return (
		<div className='w-full h-full flex'>
			<div className='relative flex flex-col z-10 h-full'>
				<div
					id='drawer-content'
					className='flex flex-col gap-4 md:gap-6 lg:gap-8 pt-6 px-5 md:px-10 overflow-y-auto w-full'
				>
					<Button
						className='px-0 py-2 bg-transparent max-w-max rounded hover:bg-transparent'
						onClick={() => (disabledOnClose ? null : closeModal())}
					>
						<Icon name='close' width='18px' height='18px' />
						<p className='font-semibold text-white ml-2'>Fechar</p>
					</Button>
					<div className='flex flex-col justify-between flex-grow'>
						<div className='flex flex-col gap-8'>
							<div className='flex flex-col gap-4'>
								{drawerInfo?.name_course && (
									<h2
										className={twMerge(
											classNames(
												'text-5xl leading-10 font-bold w-full max-w-[650px] text-white',
												{
													'text-[44px] leading-10':
														drawerInfo?.name_course?.length >= 8,
													'text-[40px] leading-10':
														drawerInfo?.name_course.length >= 16,
													'text-[38px] leading-10':
														drawerInfo?.name_course.length >= 24,
													'text-4xl leading-10':
														drawerInfo?.name_course.length >= 32,
												}
											)
										)}
									>
										{drawerInfo?.name_course || ''}
									</h2>
								)}
								<p className='text-white leading-6 w-full max-w-[680px]'>
									{drawerInfo?.description_course || ''}
								</p>
							</div>
							<div className='flex flex-col gap-8 lg:pr-6 pb-6 flex-1 overflow-y-auto'>
								<div className='flex flex-col md:flex-row gap-3 md:gap-6 md:items-center'>
									<Button
										className='bg-white hover:bg-white max-w-max px-4 py-2 h-auto rounded-full pointer-events-none'
										onClick={() => (disabledOnClose ? null : closeModal())}
									>
										<Icon name='play' width='20px' height='20px' />
										<p className='font-semibold text-[#150E1D] text-sm ml-2'>
											Curso ao vivo
										</p>
									</Button>
								</div>
								<div className='w-full flex flex-col gap-6 py-6 bg-white/10 rounded-[10px]'>
									<div className='flex flex-col gap-8'>
										<div className='flex flex-col gap-3 px-7'>
											<p className='text-2xl text-white font-medium'>
												Como funciona um curso ao vivo?
											</p>
											<p className='text-white/80'>
												No curso ao vivo, você terá aulas síncronas 2 vezes na
												semana de acordo com seu nível de proficiência. Além de
												seguir uma trilha de aprendizado dividida em módulos e
												ciclos.
											</p>
										</div>
										<div className='flex flex-col gap-4'>
											<span className='text-xs font-medium leading-3 text-white/70 px-7'>
												ETAPAS PARA INÍCIO DO CURSO
											</span>
											<div className='grid pl-7'>
												<div className='grid grid-cols-[minmax(160px,_1fr)_minmax(160px,_1fr)_minmax(160px,_1fr)_minmax(128px,_128px)] overflow-x-auto w-full pb-2'>
													{[
														'Matrícula no curso',
														'Teste de Nivelamento',
														'Alocação na turma',
														'Início das aulas',
													].map((etapa, index) => (
														<div
															key={index}
															className='flex flex-col gap-2 min-w-[100px] flex-shrink-0'
														>
															<div className='relative flex items-center'>
																<div className='relative flex'>
																	<Icon
																		name='circle-timeline'
																		width='16px'
																		height='16px'
																		className='relative z-10'
																	/>
																</div>
																{index < 3 && (
																	<div className='w-full h-[1px] bg-[#6140D6]' />
																)}
															</div>
															<p className='text-[13px] text-white font-medium'>
																{etapa}
															</p>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
									<div className='flex flex-col px-7'>
										<Button
											className='px-0 py-0 bg-transparent max-w-max h-auto rounded opacity-70 hover:opacity-100 hover:bg-transparent'
											onClick={() =>
												window.open('https://help.fluency.io', '_blank')
											}
										>
											<p className='text-sm font-semibold mr-2 text-zinc-50'>Saiba mais</p>
											<Icon name='arrow-up-right' width='16px' height='16px' />
										</Button>
									</div>
								</div>
								{drawerInfo?.about_course?.length && (
									<div className='flex flex-col gap-4'>
										<p className='text-2xl text-white font-medium'>
											Sobre o curso
										</p>

										<div className='flex flex-col gap-4'>
											{drawerInfo.about_course.map((item, key) => (
												<p className='text-white/80' key={key}>
													{item}
												</p>
											))}
										</div>
									</div>
								)}
								{drawerInfo?.units?.length && (
									<div className='flex flex-col gap-4'>
										<p className='text-white uppercase font-semibold'>
											Módulos
										</p>
										<div className='flex flex-col gap-2'>
											{drawerInfo.units.map((unit, key) => (
												<div
													className='flex items-center py-2 px-3 bg-white/5 rounded-lg'
													key={key}
												>
													<span className='text-white font-medium'>
														{key + 1}. {unit}
													</span>
												</div>
											))}
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className='flex flex-col bg-[#2B2237] border-t border-white/10 px-5 md:px-10 py-4 pb-5 flex-shrink-0'>
					{(() => {
						if (
							['AO VIVO'].includes(typeCourse) &&
							user?.curso_interesse_id &&
							user?.curso_interesse_id === drawerInfo?.curso_id
						) {
							return (
								<div className='flex flex-col gap-2 md:gap-3 md:flex-row items-center justify-between'>
									<Button
										className='md:max-w-max rounded-full bg-brand-primary/70 px-8'
										onClick={() => {
											closeModal()
											const formattedCourse = {
												id: undefined,
												name: drawerInfo.name_course,
												curso_id: drawerInfo.curso_id,
												progress: undefined,
												status: undefined,
												'type-course': 'AO VIVO',
											}

											dispatch(
												matriculateCreators.setClassSelect(formattedCourse)
											)
											navigate('/curso')
										}}
										isLoading={isLoading}
									>
										<p className='font-semibold text-white'>
											Finalizar onboarding
										</p>
									</Button>
									{(() => {
										if (
											['AO VIVO'].includes(typeCourse) &&
											findOnboarding?.nivel_onboarding === 4
										) {
											return (
												<p className='font-semibold text-white animate-pulse'>
													Aguardando alocação na turma
												</p>
											)
										}

										return <></>
									})()}
								</div>
							)
						}

						if (
							['AO VIVO'].includes(typeCourse) &&
							user?.curso_interesse_id &&
							findOnboarding?.nivel_onboarding !== 5 &&
							user?.curso_interesse_id !== drawerInfo?.curso_id
						) {
							return (
								<Button className='max-w-max rounded-lg bg-transparent hover:bg-transparent px-0 pointer-events-none'>
									<p className='font-semibold text-white'>
										Aguardando alocação em uma turma
									</p>
								</Button>
							)
						}

						return (
							<Button
								className='max-w-max rounded-full px-6'
								onClick={() => {
									handleMatriculatedLive()
								}}
								isLoading={isLoading || isLoadingOnboarding}
								disabled={!['GRAVADO', 'AO VIVO'].includes(typeCourse)} // Melhora a verificação de disabled
							>
								<p className='font-semibold text-inherit'>Fazer matrícula no curso</p>
							</Button>
						)
					})()}
				</div>
			</div>
		</div>
	)
}
